import React from 'react'
import SocialMM from '../assests/Social-media-management-img.png'

function Content() {
  return (
    <div className='100vh 100vw bg-gradient-to-br from-[#001002] via-[#000000] to-[#001002] md:py-16 py-10 text-white'>

      <div className='md:max-w-[1240px]  mx-auto md:flex md:justify-around md:text-left'>

      <div className='p-7 md:p-0 md:px-4 lg:px-0 lg:pr-4 m-auto'>
        <img src={SocialMM} alt="" />
      </div> 

      <div  className='p-7 md:p-0 justify-evenly md:pl-5'>
        <h1 className='px-3 text-center md:text-left font-semibold text-3xl md:text-5xl text-white pb-7 md:pb-0'>Social Media Management</h1>
        <div className=' '>
          <ul>
            <li>
             <p className='text-xl'>
               <span className=' font-semibold'>Strategic Content Curation:</span> <span className='text-[#808080]'>Engaging posts tailored to your audience's interests.</span> 
             </p> 
            </li>

            <li>
             <p className='text-xl'>
               <span className=' font-semibold'>Community Engagement:</span> <span className='text-[#808080]'>Building loyalty through active interaction and conversation.</span> 
             </p> 
            </li>
             
            <li>
             <p className='text-xl'>
               <span className=' font-semibold'>Data-Driven Insights:</span> <span className='text-[#808080]'> Metrics guide strategy for optimal social performance.</span> 
             </p> 
            </li>
          </ul>
         
        </div>
        <div className='text-center md:text-left'>
        <button className=" mt-5  py-2 md:py-3 px-8 mx-3 bg-black text-white ">
              Contact Us
        </button>
        </div>
      </div>
      </div>
    </div>
  )
}

export default Content